/**
 * Takes current site ID and checks for scene 7 image path set insettings.py
 * NOTE: Removed AB testing logic for UW-17439, check git history to retrieve it
 * @param   {object} thirdParty     data point from core
 * @param   {string} siteId         siteId to access data by
 * @returns {string}                path to image
 */
export function getScene7ImagePath(thirdParty, siteId = 'default') {
    return _.get(thirdParty, `${siteId}.scene7.image_path`,
                          _.get(thirdParty, 'default.scene7.image_path', '/'));
}

/**
 * Takes current site ID and checks for scene 7 video path set insettings.py
 * @param   {object} thirdParty     data point from core
 * @param   {string} siteId         siteId to access data by
 * @returns {string}                path to video
 */
export function getScene7VideoPath(thirdParty, siteId = 'default') {
    return _.get(thirdParty, `${siteId}.scene7.video_path`,
                          _.get(thirdParty, 'default.scene7.video_path', '/'));
}

export function getSlug(styleNumber, colorId, viewCode) {
    return `${ styleNumber }_${ colorId }_${ viewCode }`;
}
